import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { IoMdArrowRoundBack } from "react-icons/io";

function BackButton() {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    }
    return (
        <div>
            <IconButton aria-label="back button" component="label" onClick={goBack} style={{color: '#fff', background: '#282881'}}>
                <IoMdArrowRoundBack fontSize='22.5px' />
            </IconButton>
        </div>
    );
}

export default BackButton;